import React from 'react';
import { Icon } from '../Icon';
import { Box } from '@mui/material';
import { TMaterialStyleItem } from '../../theme';
import './styles/loader.css';

interface ILoader {
  sx?: TMaterialStyleItem;
  iconSx?: TMaterialStyleItem;
}

export const Loader: React.FC<ILoader> = ({ sx, iconSx }) => {
  return (
    <Box sx={sx}>
      <Icon className="loader" sx={iconSx} iconName="Loader" />
    </Box>
  );
};
